@if (initialized()) {
  <div class="page">
    @if (data() && data().article) {
      <app-share-float
        [pdfUrl]="data().article?.pdf[0]?.download_link | assetFormatter"
      ></app-share-float>

      @if (data().article!.media_type === "video") {
        <div class="container container-site mx-auto py-4">
          <div class="row gy-4">
            <div class="col-md-8 py-4">
              <div class="px-3">
                <div class="d-flex align-items-center mb-auto">
                  <div>
                    <img
                      src="/img/logo_liber_olive.webp"
                      alt="Liber"
                      height="30"
                    />
                  </div>

                  <img src="/img/video_icon_b.webp" alt="Icono" width="40" />
                </div>

                @if (iframe()) {
                  <div [innerHTML]="iframe()" class="mt-4"></div>
                }
              </div>

              <div
                class="article-content article-content-first-letter mt-4"
                [innerHTML]="data().article?.content"
              ></div>
            </div>

            <div class="col-md-4 align-self-center">
              <div class="article-card-detail">
                <div class="row">
                  @if (data().article?.subject?.name) {
                    <div class="col-12">
                      <span class="text-uppercase category-badge">
                        {{ data().article?.subject?.name }}
                      </span>
                    </div>
                  }

                  <div class="col-12">
                    <p class="h3 mt-2">
                      {{ data().article!.title }}
                    </p>

                    <hr class="separator my-2" />
                  </div>
                </div>

                @if (data().article && data().article?.tags) {
                  <div class="card bg-card mt-4">
                    <div class="card-body">
                      <h3 class="h5">Palabras clave</h3>

                      <div class="row w-100 gx-2">
                        @for (
                          tag of data()!.article!.tags.split(",");
                          track tag
                        ) {
                          <div class="col-auto">
                            <a
                              class="tag-pill"
                              [routerLink]="['/buscar']"
                              [queryParams]="{ t: tag }"
                              >#{{ tag }}</a
                            >
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>

            <div class="col-md-8">
              @if (data().interest && data().interest.length > 0) {
                <div class="w-100">
                  <hr />

                  <div class="article-interest">
                    <p class="h5 mb-3">Continuar</p>

                    <app-carousel
                      [items]="data().interest"
                      carouselType="videos-detail"
                    ></app-carousel>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      } @else {
        <div class="container container-site pt-4 pt-lg-5 mx-auto">
          <!-- Header -->
          <div class="row gy-4">
            @if (data().article?.image) {
              <div class="col-12 col-md-8 text-center">
                <div class="d-inline-block">
                  <img
                    [src]="data().article!.image | assetFormatter"
                    class="article-image"
                    [alt]="data().article!.title"
                  />

                  @if (data().article!.caption) {
                    <div class="pt-2 article-caption text-start">
                      {{ data().article!.caption }}
                    </div>
                  }
                </div>

                <div class="w-100 py-3">
                  <button
                    type="button"
                    class="btn btn-primary btn-md"
                    (click)="togglePlay()"
                  >
                    <i
                      class="fas me-2"
                      [ngClass]="{
                        'fa-pause': playing(),
                        'fa-play': !playing(),
                      }"
                    ></i>
                    @if (playing()) {
                      Detener
                    } @else {
                      Escuchar
                    }
                  </button>
                </div>
              </div>
            }

            <div
              class="col-12 col-md-4 d-flex align-items-start flex-column"
              [ngClass]="{
                'mt-auto align-self-end': !(
                  data().magazine && data().magazine!.number
                ),
              }"
            >
              <div class="article-card-detail">
                @if (
                  data().magazine &&
                  data().magazine!.number &&
                  data().article?.category_id !== 9 &&
                  data().article?.category_id !== 10
                ) {
                  <div class="liber-number h2 mb-auto">
                    <div>
                      <img
                        src="/img/logo_liber_olive.webp"
                        alt="Liber"
                        height="30"
                      />
                    </div>

                    <div class="liber-number-circle">
                      {{ data().magazine!.number }}
                    </div>
                  </div>

                  <div class="w-100 my-3"></div>
                }

                @if (
                  data().article?.category_id !== 9 &&
                  data().article?.category_id !== 10
                ) {
                  @if (data().article?.subject?.name) {
                    <span class="text-uppercase category-badge">
                      {{ data().article?.subject?.name }}
                    </span>
                  }
                } @else {
                  @if (data().article?.category) {
                    <span class="text-uppercase category-badge mb-4">
                      {{ data().article?.category?.name }}
                    </span>
                  }

                  @if (data().article?.subject) {
                    <p class="category-badge-text">
                      {{ data().article?.subject?.name }}
                    </p>
                  }
                }

                <div class="w-fit mb-3">
                  <h1 class="h3 mb-3">{{ data().article?.title }}</h1>

                  <div class="separator"></div>
                </div>

                <div [innerHTML]="data().article?.meta_description"></div>

                @if (data().article?.author) {
                  <hr class="separator" />

                  <a
                    class="author-label"
                    [routerLink]="['/buscar']"
                    [queryParams]="{ a: data()!.article!.author!.id }"
                    >Por
                    {{
                      data().article!.author?.name +
                        " " +
                        data().article!.author?.surname
                    }}</a
                  >
                }
              </div>
            </div>
          </div>

          <!-- Body + sidebar -->
          <div class="row pt-4">
            <div class="col-12 col-md-8">
              @if (data().article?.notes) {
                <div
                  class="small text-end"
                  [innerHTML]="data().article?.notes"
                ></div>
              }

              <div
                class="article-content article-content-first-letter"
                [innerHTML]="data().article?.content"
              ></div>

              @if (data().article?.author) {
                <div class="article-author mb-4">
                  <h4 class="mb-4">Autor</h4>

                  <div class="d-flex align-items-center">
                    @if (data().article?.author?.photo) {
                      <div class="img-circle-avatar-xl me-3">
                        <img
                          [src]="data().article!.author!.photo | assetFormatter"
                          [alt]="data().article?.author?.name"
                        />
                      </div>
                    }
                    <div>
                      <p class="author-label font-monospace h5 mb-0">
                        {{
                          data().article!.author?.name +
                            " " +
                            data().article!.author?.surname
                        }}
                      </p>
                    </div>
                  </div>
                  @if (data().article!.author?.bio) {
                    <div
                      class="mt-3"
                      [innerHTML]="data().article!.author?.bio"
                    ></div>
                  }
                </div>
              }

              @if (data().related) {
                <hr />

                <div class="row gy-3 mb-4">
                  <div class="col-12">
                    <p class="h5 mb-3">
                      Continúa leyendo esta edición de Liber
                    </p>
                  </div>

                  <div class="col-md-auto">
                    <span class="text-uppercase category-badge w-100">
                      {{ data().article?.subject?.name }}
                    </span>

                    <a [routerLink]="['/articulo', data().related!.slug]">
                      <div class="related-image">
                        <img
                          [src]="data().related?.cover | assetFormatter"
                          class="img-fluid img-zoomable"
                          [alt]="data().related!.title"
                        />
                      </div>
                    </a>
                  </div>

                  <div class="col-md">
                    <p class="h5 mt-2">
                      <a [routerLink]="['/articulo', data().related!.slug]">
                        {{ data().related!.title }}
                      </a>
                    </p>

                    @if (data().related!.subtitle) {
                      <p class="mb-2">
                        {{ data().related!.subtitle }}
                      </p>
                    }

                    @if (data().related!.meta_description) {
                      @if (data().related!.meta_description.length > 130) {
                        <div
                          [innerHTML]="
                            data().related!.meta_description.slice(0, 130) +
                            '...'
                          "
                        ></div>
                      } @else {
                        <div
                          [innerHTML]="data().related!.meta_description"
                        ></div>
                      }
                    }

                    @if (data().related!.author) {
                      <a
                        class="author-label d-block"
                        [routerLink]="['/buscar']"
                        [queryParams]="{ a: data().related!.author?.id }"
                      >
                        <span class="fw-bold">
                          Por
                          {{
                            data().related!.author.name +
                              " " +
                              data().related!.author.surname
                          }}
                        </span>
                      </a>
                    }
                  </div>
                </div>
              }

              @if (data().interest && data().interest.length > 0) {
                <hr />

                <div class="article-interest">
                  <p class="h5 mb-3">Te podría interesar</p>

                  <app-carousel
                    [items]="data().interest"
                    carouselType="interest"
                  ></app-carousel>
                </div>
              }
            </div>

            <div class="col-12 col-md-4">
              <div class="article-sidebar p-4">
                @if (data().magazine) {
                  <div>
                    <p class="h5 mb-3 fw-normal font-monospace">
                      Aparece en {{ data().magazine?.title }}
                    </p>

                    <img
                      [src]="data().magazine?.cover | assetFormatter"
                      class="img-fluid"
                      [alt]="data().magazine?.title"
                    />

                    @if (data().magazine?.pdf && data().article?.pdf) {
                      <div class="d-flex flex-column my-4">
                        @if (data().magazine?.pdf[0]) {
                          <a
                            class="btn btn-outline-dark btn-md mb-4"
                            [href]="
                              data().magazine?.pdf[0].download_link
                                | assetFormatter
                            "
                            target="_blank"
                            rel="noopener"
                          >
                            Ver Liber en PDF
                          </a>
                        }

                        @if (
                          data().article?.pdf && data().article!.pdf.length > 0
                        ) {
                          <a
                            class="btn btn-primary btn-md"
                            [href]="
                              data().article?.pdf[0].download_link
                                | assetFormatter
                            "
                            target="_blank"
                            rel="noopener"
                          >
                            Ver artículo en PDF
                          </a>
                        }
                      </div>
                    }
                  </div>
                }

                @if (data().article && data().article?.tags) {
                  <h3 class="h5 pt-3">Palabras clave</h3>
                  <p class="tags">
                    @for (tag of data()!.article!.tags.split(","); track tag) {
                      <a
                        class="tag-pill"
                        [routerLink]="['/buscar']"
                        [queryParams]="{ t: tag }"
                        >#{{ tag }}</a
                      >
                    }
                  </p>
                }
              </div>
            </div>
          </div>
        </div>
      }
    }
  </div>
} @else {
  <app-spinner></app-spinner>
}
